import Dashboard from "./dashboard";

import FtmList from "./ftm/list";
import FtmView from "./ftm/view";
import FtmPendingApplication from "./ftm/pendingApplication";
import AllLogs from "./ftm/logs/all";
import FTMRejectedJobs from "./ftm/rejectedJobs";
import TradespersonHolidays from "./ftm/holidays";
import FtmRejectedApplications from "./ftm/rejectedApplications";

import AllJobs from "./jobs/all";
import OngoingJobs from "./jobs/ongoing";
import CompliedJobs from "./jobs/completed";
import NotAttended from "./jobs/notAttended";
import DisputesList from "./jobs/disputes/list";
import Chat from "./jobs/disputes/chat";
import RemedialJobs from "./jobs/remedial";
import RecallVisits from "./jobs/recallVisits";
import AllDisputes from "./jobs/disputes/all";

import AllPayments from "./payments/all";
import FtmPayments from "./payments/ftm";
import Skills from "./serviceCategory/skills";
import SearchResults from "./jobs/searchResults";
import Lockscreen from "./lockscreen";
import CancelJobs from "./jobs/cancelJobs/all";
import FtmCancelJobs from "./jobs/cancelJobs/ftm";
import Summary from "./payments/summary";
import Profile from "./user/profile";
import UsersList from "./user/list";
import ForgotPassword from "./forgotPassword";
import FtmPaymentsHistories from "./payments/ftmPaymentsHistories";
import Notifications from "./notifications";
import FtmRevenue from "./ftm/revenue";
import FtmRatings from "./ftm/ratings";

import AllCustomers from "./customers/all";
import CustomerView from "./customers/view";
import Auth from "./auth";
import FtmHistory from "./ftm/history";
import DisputesInbox from "./jobs/disputes/inbox";
import RunningJobsList from "./jobs/runningJobs/list";
import OfficeMessagesInbox from "./messages/office";
import JobsMessagesInbox from "./messages/jobs";
import DisputeMessagesInbox from "./messages/disputes";
import Invoices from "./ftm/invoices/";

import Error404 from "./error/404";
import Error403 from "./error/403";
import ExpiredDocuments from "./ftm/documents/expired/Expired";
import Undecided from "./jobs/undecided/Undecided";
import FtmApprovalProcess from "./ftm/approvalProcess/ApprovalProcess";
import FtmProfile from "./ftm/profile/Profile";
import JobDetails from "./jobs/details/JobDetails";
import Jobsheet from "./jobs/jobsheet/Jobsheet";
import JobInvoices from "./jobs/jobInvoices/JobInvoices";
import Financial from "./financial/Financial";
import Valuation from "./ftm/valuation/Valuation";

export const routes = [
    { path: "/", element: <Auth />, page_name: "Auth" },
    { path: "/auth", element: <Auth />, page_name: "Auth" },
    { path: "/dashboard", element: <Dashboard />, page_name: "Dashboard", protected: true, roles: [1, 2] },
    { path: "/ftm/approval-process/:ftm_id", element: <FtmApprovalProcess />, page_name: "Ftm Approval Process", protected: true, roles: [1, 2] },
    { path: "/ftm/list", element: <FtmList />, page_name: "Tradesperson List", protected: true, roles: [1, 2] },
    { path: "/ftm/view/:ftm_id", element: <FtmView />, page_name: "Tradesperson", protected: true, roles: [1, 2] },
    { path: "/ftm/profile/:ftm_id", element: <FtmProfile />, page_name: "Tradesperson", protected: true, roles: [1, 2] },
    { path: "/ftm/pending/application", element: <FtmPendingApplication />, page_name: "Pending Application", protected: true, roles: [1, 2] },
    { path: "/ftm/all/logs", element: <AllLogs />, page_name: "All Logs", protected: true, roles: [1, 2] },
    { path: "/ftm/rejected/jobs", element: <FTMRejectedJobs />, page_name: "Rejected Jobs", protected: true, roles: [1, 2] },
    { path: "/ftm/holidays", element: <TradespersonHolidays />, page_name: "Tradesperson Holidays", protected: true, roles: [1, 2] },
    { path: "/ftm/rejected/applications", element: <FtmRejectedApplications />, page_name: "Rejected Applications", protected: true, roles: [1, 2] },
    { path: "/customers/all", element: <AllCustomers />, page_name: "All Customers", protected: true, roles: [1, 2] },
    { path: "/customers/view/:customer_id", element: <CustomerView />, page_name: "Customer", protected: true, roles: [1, 2] },
    { path: "/jobs/all", element: <AllJobs />, page_name: "All Jobs", protected: true, roles: [1, 2] },
    { path: "/jobs/ongoing", element: <OngoingJobs />, page_name: "Ongoing Jobs", protected: true, roles: [1, 2] },
    { path: "/jobs/complied/:nav_type", element: <CompliedJobs />, page_name: "Complied Jobs", protected: true, roles: [1, 2] },
    { path: "/jobs/not/attended", element: <NotAttended />, page_name: "Not Attended", protected: true, roles: [1, 2] },
    { path: "/jobs/details/:job_id", element: <JobDetails />, page_name: "Job details", protected: true, roles: [1, 2] },
    { path: "/jobs/disputes/all", element: <AllDisputes />, page_name: "All Disputes", protected: true, roles: [1, 2] },
    { path: "/jobs/disputes/list", element: <DisputesList />, page_name: "Disputes List", protected: true, roles: [1, 2] },
    { path: "/jobs/disputes/inbox", element: <DisputesInbox />, page_name: "Disputes Inbox", protected: true, roles: [1, 2] },
    { path: "/jobs/disputes/chat", element: <Chat />, page_name: "Chat", protected: true, roles: [1, 2] },
    { path: "/jobs/cancel", element: <CancelJobs />, page_name: "Cancel Jobs", protected: true, roles: [1, 2] },
    { path: "/jobs/recall/visits", element: <RecallVisits />, page_name: "Recall Visits", protected: true, roles: [1, 2] },
    { path: "/ftm/jobs/cancel/:ftm_id", element: <FtmCancelJobs />, page_name: "Tradesperson Cancel Jobs", protected: true, roles: [1, 2] },
    { path: "/all/payments", element: <AllPayments />, page_name: "All Payments", protected: true, roles: [1, 2] },
    { path: "/ftm/payments/:ftm_id", element: <FtmPayments />, page_name: "Tradesperson Payments", protected: true, roles: [1, 2] },
    { path: "/ftm/payments/histories/:ftm_id", element: <FtmPaymentsHistories />, page_name: "Tradesperson Payments Histories", protected: true, roles: [1, 2] },
    { path: "/ftm/revenue", element: <FtmRevenue />, page_name: "Tradesperson Revenue", protected: true, roles: [1, 2] },
    { path: "/ftm/ratings", element: <FtmRatings />, page_name: "Tradespersons Ratings", protected: true, roles: [1, 2] },
    { path: "/ftm/invoices", element: <Invoices />, page_name: "Tradesperson Invoices", protected: true, roles: [1, 2] },
    { path: "/ftm/valuation/:ftm_id", element: <Valuation />, page_name: "Tradesperson Valuation", protected: true, roles: [1, 2] },
    { path: "/payments/summary", element: <Summary />, page_name: "Summary", protected: true, roles: [1, 2] },
    { path: "/skills", element: <Skills />, page_name: "Service Categories", protected: true, roles: [1] },
    { path: "/job/search/results", element: <SearchResults />, page_name: "Search Results", protected: true, roles: [1, 2] },
    { path: "/lockscreen", element: <Lockscreen />, page_name: "Lockscreen", protected: false, roles: [] },
    { path: "/profile", element: <Profile />, page_name: "Profile", protected: true, roles: [1, 2] },
    { path: "/users/list", element: <UsersList />, page_name: "Users List", protected: true, roles: [1, 2] },
    { path: "/notifications", element: <Notifications />, page_name: "Notifications", protected: true, roles: [1, 2] },
    { path: "/forgot/password/:forgot_password_key", element: <ForgotPassword />, page_name: "Forgot Password", protected: false, roles: [] },
    { path: "/ftm/history/:ftm_id", element: <FtmHistory />, page_name: "Tradesperson History", protected: true, roles: [1, 2] },
    { path: "/jobs/remedial", element: <RemedialJobs />, page_name: "Remedial Jobs", protected: true, roles: [1, 2] },
    { path: "/running/jobs/schedule", element: <RunningJobsList />, page_name: "Schedule Jobs", protected: true, roles: [1, 2] },
    { path: "/messages/office/inbox", element: <OfficeMessagesInbox />, page_name: "Office Messages", protected: true, roles: [1, 2] },
    { path: "/messages/jobs/inbox", element: <JobsMessagesInbox />, page_name: "Jobs Messages", protected: true, roles: [1, 2] },
    { path: "/messages/disputes/inbox", element: <DisputeMessagesInbox />, page_name: "Disputes Messages", protected: true, roles: [1, 2] },
    { path: "/expired/documents", element: <ExpiredDocuments />, page_name: "Expired Documents", protected: true, roles: [1, 2] },
    { path: "/undecided/requests", element: <Undecided />, page_name: "Undecided Requests", protected: true, roles: [1, 2] },
    { path: "/job/invoices/:job_id", element: <JobInvoices />, page_name: "Job Invoices", protected: true, roles: [1, 2] },
    { path: "/jobsheet/:job_id", element: <Jobsheet />, page_name: "Jobsheet", protected: true, roles: [1, 2] },
    { path: "/financial", element: <Financial />, page_name: "Financial", protected: true, roles: [1, 2] },
    { path: "/access-denied", element: <Error403 />, page_name: "403 Error" },
    { path: "/*", element: <Error404 />, page_name: "404 Error" },
];